import React from "react";
import { connect } from "react-redux";
import {
  Button,
  TextField,
  Grid,
  Box,
  Typography,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { Helmet } from "react-helmet";
import { Formik } from "formik";
import * as Yup from "yup";
import { UserActions } from "../redux/actions/UserActions";


const useStyles = (theme) => ({
  paper: {
    marginTop: theme.spacing(3),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    backgroundColor: "#fff",
    padding: theme.spacing(4),
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  typography: {
    marginTop: theme.spacing(3),
  },
  divider: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  buttons: {
    display: "flex",
    justifyContent: "center",
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
});

class AdminRegistration extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: this.props.username,
      oneTimePassword: "",
      isEnableResendMsg: false,
      submitted: false,
      showResend: false,
      isSendOTPSuccess: false,
      isSendOTPError: false,
    };
  }

  handleResendMsg() {
    this.setState({ showResend: false});
    this.props.sendOTP(this.state.username);
    setTimeout(() => this.setState({ showResend: this.state.isSendOTPSuccess?true:false }), 5000);
  }

  componentDidMount() {
    this.props.sendOTP(this.state.username);
  }

  componentDidUpdate(prevProps) {
    if (!this.state.isSendOTPSuccess && this.props.isSendOTPSuccess) {
      this.setState({ isSendOTPSuccess: true, showResend: false });
    }
    if (!this.state.isSendOTPError && this.props.isSendOTPError) {
      this.setState({ isSendOTPError: true, showResend: false });
    }
  }

  validationObject = () => {
    let validationObject = {
      oneTimePassword: Yup.string()
        .required("Enter otp")
        .matches(/^[0-9]+$/, "Otp must be only digits")
        .max(6, "Please enter 6 digit otp")
        .min(6, "Please enter 6 digit otp"),
    };
    return validationObject;
  };

  render() {
    if(this.state.isSendOTPSuccess !== this.props.isSendOTPSuccess){
      setTimeout(() => this.setState({ showResend: true }), 5000);
    }
    const classes = this.props.classes;
    return (
      <>
        <Helmet>
          <title>Patient portal | Secret question</title>
        </Helmet>

        <Formik
          enableReinitialize
          initialValues={{
            oneTimePassword: '',
          }}
          validationSchema={Yup.object().shape(this.validationObject())}
          onSubmit={(values, { setSubmitting }) => {
            this.setState({ submitted: true });
            var paylod = {
              username: this.state.username,
              otp: values.oneTimePassword,
            };
            this.props.validate(paylod);
          }}
        >
          {({
            errors,
            handleBlur,
            handleChange,
            handleSubmit,
            touched,
            values,
          }) => (
            <form
              onSubmit={handleSubmit}
              className={classes.form}
              noValidate
              name="form"
            >
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                  <Typography
                    component="h1"
                    variant="h5"
                    className={classes.typography}
                  >
                    Validate one time password
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <TextField
                    margin="normal"
                    error={Boolean(
                      touched.oneTimePassword && errors.oneTimePassword
                    )}
                    fullWidth
                    helperText={
                      touched.oneTimePassword && errors.oneTimePassword
                    }
                    label={"One time password"}
                    name="oneTimePassword"
                    onBlur={handleBlur}
                    onChange={(e) => {
                      this.setState({ submitted: false });
                      handleChange(e);
                    }}
                    value={values.oneTimePassword}
                    variant="outlined"
                    autoComplete="off"
                  />

                  <Box display="flex">
                    <Box p={1} flexGrow={1}>
                      {this.state.isSendOTPSuccess && (
                        <p style={{ color: "green" }}>OTP send successfully</p>
                      ) }
                      {this.state.isSendOTPError && (
                        <p style={{ color: "red" }}>
                          Your account has been locked. Please call the doctor's
                          office.{" "}
                        </p>
                      )}
                    </Box>
                    <Box>
                      <Button
                        disabled={!this.state.showResend}
                        color={!this.state.showResend ? "secondary" : "default"}
                        onClick={() => {
                          this.handleResendMsg();
                        }}
                      >
                        Resend OTP
                      </Button>
                    </Box>
                  </Box>
                </Grid>
              </Grid>

              <div className={classes.buttons}>
                <Button
                  variant="contained"
                  color="default"
                  className={classes.button}
                  onClick={() => {
                    this.props.handleBack();
                  }}
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  color="secondary"
                  className={classes.button}
                  disabled={this.state.submitted}
                >
                  Validate
                </Button>
              </div>
            </form>
          )}
        </Formik>
      </>
    );
  }
}

function mapStateToProps(state) {
  const userId = state.authentication.user.id;
  const isSendOTPSuccess = state.authentication.isSendOTPSuccess;
  const isSendOTPError = state.authentication.isSendOTPError;
  return {
    userId,
    isSendOTPSuccess,
    isSendOTPError
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    sendOTP: (username) => {
      dispatch(UserActions.sendOTP({ username: username }));
    },
    validate: (data) => {
      dispatch(UserActions.validateOTP(data));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles, { withTheme: true })(AdminRegistration));
